( function () {
   
    'use strict';
  
    ( function ( $ ) {
        var swiper = new Swiper(".product-swiper", {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '.swiper-button-next.two',
                prevEl: '.swiper-button-prev.two',
            },
            breakpoints: {
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                  destroy: false,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                  destroy: false,
                },
                1061: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                  destroy: false,
                },
                1350: {
                    slidesPerView: "4",
                    spaceBetween: 30, 
                    destroy: true,
                    loop: false,
                },
              },
          });
} )( jQuery );
} )();